import { Injectable } from '@angular/core';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResourceData } from '@app/shared/abstract/resource.data';
import { ProductModel } from './product.model';
import { ProductVariantOptionModel } from './product-variant-option.model';

@Injectable({
  providedIn: 'root',
})
export class ProductVariantOptionService extends AbstractEntityService<ProductVariantOptionModel> {
  constructor(http: HttpClient) {
    super('/api/product-variant-options', http);
  }

}
